import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'

const collapseAnimationTime = 350
const collapseTimeouts = {}

const Container = styled.div`
  button {
    svg {
      transition: transform 0.35s ease-in-out;
    }

    &.open {
      svg {
        transform: rotate(180deg);
      }
    }
  }
`

export const Collapse = (props) => {
  if (props.children.length !== 2) {
    console.error('Collapse element requires exactly 2 children')
  }

  const { control, initiallyOpen, children } = props

  const [Header, Body] = children

  const openOnFocus = useCallback((event) => {
    const collapse = event.target.closest('.collapse')
    if (collapse && !collapse.classList.contains('show')) {
      const collapseToggle = collapse.parentNode.querySelector('button')
      if (CollapseToggle) {
        collapseToggle.click()
      }
    }
  }, [])

  useEffect(() => {
    window.addEventListener('focusin', openOnFocus)

    return () => window.removeEventListener('focusin', openOnFocus)
  }, [openOnFocus])

  useEffect(() => {
    if (initiallyOpen && control.current) {
      control.current.classList.add('show')
    }
  }, [initiallyOpen, control])

  return (
    <Container>
      {Header}
      <div className="collapse" ref={control}>
        {Body}
      </div>
    </Container>
  )
}

export const CollapseToggle = (props) => {
  const { controls, className, initiallyOpen, children } = props

  const [isOpen, setOpen] = useState(initiallyOpen)

  const toggle = () => {
    const node = controls.current

    if (!node) {
      return
    }

    if (node.classList.contains('collapsing')) {
      return
    }

    if (collapseTimeouts[node]) {
      clearTimeout(collapseTimeouts[node])
      delete collapseTimeouts[node]
    }

    const shouldShow = !node.classList.contains('show')

    setOpen(shouldShow)

    node.classList.remove('collapse', 'show', 'collapsing')
    node.style = ''

    const childStyle = window.getComputedStyle(node.firstElementChild)
    const marginTop = parseInt(childStyle.marginTop) || 0
    const marginBottom = parseInt(childStyle.marginBottom) || 0
    const height = node.offsetHeight + marginTop + marginBottom

    if (shouldShow) {
      node.style.height = `0px`
      node.classList.add('collapsing')

      setTimeout(() => {
        node.style.height = `${height}px`
      }, 0)

      collapseTimeouts[node] = setTimeout(() => {
        node.classList.remove('collapsing')
        node.classList.add('collapse', 'show')
        node.style.height = ''
        delete collapseTimeouts[node]
      }, collapseAnimationTime)
    } else {
      node.style.height = `${height}px`
      node.classList.add('collapsing')

      setTimeout(() => {
        node.style.height = `${0}px`
      }, 0)

      collapseTimeouts[node] = setTimeout(() => {
        node.classList.remove('collapsing')
        node.classList.add('collapse')
        node.style.height = ''
        delete collapseTimeouts[node]
      }, collapseAnimationTime)
    }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className={`collapse-control ${className || ''} ${isOpen ? 'open' : ''}`}
      tabIndex="-1"
    >
      {children}
    </button>
  )
}
